/* @jsxImportSource react */

import type { ReactNode, FC } from 'react';
import { SWRConfig } from 'swr';

import type { Device } from '@packages/shared/src/utils/types';
import type { Locale } from '@packages/config';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';

import { DefaultHeader } from './DefaultHeader';
import { MinimalHeader } from './MinimalHeader';
import { PaceId } from './PaceId';
import { SearchHistoryUpdater } from './SearchHistoryUpdater';
import { AbTestEnrollments } from './AbTestEnrollments';
import { SessionCartInfoTracking } from './SessionCartInfoTracking';
import { PersistentScrid } from './PersistentScrid';
import { PostLoginActionsHandler } from '../PostLoginActions/PostLoginActionsHandler.client';

export type HeaderProps = {
  locale: Locale;
  isMinimal?: boolean;
  device: Device;
  navigation?: ReactNode;
};

export const Header: FC<HeaderProps> = ({ locale, isMinimal, device, navigation }) => (
  <>
    {process.env.NODE_ENV !== 'development' && (
      <ErrorBoundary>
        <PaceId />
      </ErrorBoundary>
    )}
    <ErrorBoundary>
      <SessionCartInfoTracking />
    </ErrorBoundary>
    <ErrorBoundary>
      <PersistentScrid />
    </ErrorBoundary>

    <SWRConfig>
      <ErrorBoundary>
        <SearchHistoryUpdater />
      </ErrorBoundary>
      <ErrorBoundary>
        <AbTestEnrollments />
      </ErrorBoundary>
    </SWRConfig>

    <ErrorBoundary>
      <PostLoginActionsHandler />
    </ErrorBoundary>

    {isMinimal ? (
      <MinimalHeader />
    ) : (
      <DefaultHeader locale={locale} device={device} navigation={navigation} />
    )}
  </>
);
